import { put } from "redux-saga/effects";

import { updateAIGeneratedMapProgressSuccess } from "domains/createMapDetail/actions";
import { FakeProgressStatuses } from "domains/createMapDetail/types";

const timeout = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export function* getAIGeneratedMapProgressSaga() {
  const fakeStatuses = [
    FakeProgressStatuses.Preparing,
    FakeProgressStatuses.Selecting,
    FakeProgressStatuses.Finalizing,
    FakeProgressStatuses.Finish,
  ];

  for (const status of fakeStatuses) {
    yield put(updateAIGeneratedMapProgressSuccess({ status }));
    yield timeout(4000);
  }
}
